import request from '@/utils/request'

const url = '/auth-service/zhishikus'

export function page(params) {
  return request({
    url: `${url}/page`,
    method: 'get',
    params: params
  })
}

export function treePermission4CurrentUser() {
  return request({
    url: `${url}/tree_permission_4_current_user`,
    method: 'get',
    params: {}
  })
}

export function tree() {
  return request({
    url: `${url}/tree`,
    method: 'get',
    params: {}
  })
}

export function view(id) {
  return request({
    url: `${url}/${id}`,
    method: 'get',
    params: {}
  })
}

export function create(params) {
  return request({
    url: `${url}`,
    method: 'post',
    params: params
  })
}

export function grant(params) {
  return request({
    url: `${url}/grant/${params.category}`,
    method: 'post',
    params: params
  })
}

export function clear(params) {
  return request({
    url: `${url}/clear/${params.category}`,
    method: 'post',
    params: params
  })
}

export function update(params) {
  return request({
    url: `${url}/${params.id}`,
    method: 'put',
    params: params
  })
}

export function remove(id) {
  return request({
    url: `${url}/${id}`,
    method: 'delete'
  })
}

export function enabled(params) {
  return request({
    url: `${url}/${params.id}/enabled/${params.enabled}`,
    method: 'put'
  })
}
